module.exports = __webpack_public_path__ + "img/ja.b944dd59.svg";